import get from 'lodash/get';

const userIsLoading = (state = true, action) => {
  switch(action.type) {
    case 'SIGN_IN_REQUEST':
    case 'SIGN_OUT_REQUEST':
    case 'SIGN_UP_REQUEST':
    case 'SEND_MAIL_VERIFICATION_REQUEST':
      return action.isLoading;
    default: return state;
  }
};

const user = (state = {}, action) => {
  switch(action.type) {
    case 'SIGN_IN_SUCCESS':
    case 'SIGN_OUT_SUCCESS':
    case 'SIGN_UP_SUCCESS':
      return action.user;
    default: return state;
  }
};

const userIsAuthenticated = (state = false, action) => {
  switch(action.type) {
    case 'SIGN_IN_SUCCESS':
    case 'SIGN_OUT_SUCCESS':
    case 'SIGN_UP_SUCCESS':
      return !!get(action, 'user.email');
    default: return state;
  }
};

const userResetPassword = (state = false, action) => {
  switch(action.type) {
    case 'RESET_PASSWORD_SUCCESS':
      return true;
    case 'RESET_PASSWORD_CLEAR':
      return false;
    default:
      return state;
  }
}

const userHasErrored = (state = false, action) => {
  switch(action.type) {
    case 'SIGN_IN_ERROR':
    case 'SIGN_OUT_ERROR':
    case 'SIGN_UP_ERROR':
    case 'SEND_MAIL_VERIFICATION_ERROR':
    case 'RESET_PASSWORD_ERROR':
      return action;
    case 'RESET_SIGN_IN':
    case 'SIGN_IN_SUCCESS':
    case 'SIGN_OUT_SUCCESS':
    case 'SIGN_UP_SUCCESS':
      return false;
    default:
      return state;
  }
};

export { user, userIsLoading, userIsAuthenticated, userHasErrored, userResetPassword };



// WEBPACK FOOTER //
// ./src/reducers/user.js